// Progress-engine contracts beyond the dashboard: the coaching CADENCE knob and the session/series
// DEBRIEF surface. ARCHITECTURE.md §9 + BUILD_PLAN S15 + V1_EXPERIENCE_VISION §10.6.
//
// Cadence and the dashboard live on different clocks. The dashboard (api.ts ProgressDashboard) is the
// all-time rollup; a debrief grades ONE RUN of hands as a unit and jumps to its best/worst decisions.
// The cadence knob chooses the grouping granularity of that debrief. Note this is a DIFFERENT axis from
// the coach package's within-hand `NarrationCadence` ('perDecision'|'perStreet'|'perHand'): that one
// paces Observe narration inside a single hand; this one paces the graded debrief across a run.
import { z } from 'zod';
import { StreetSchema } from './position';
/** When the graded coaching/debrief surfaces across a run (V1_EXPERIENCE_VISION §10.6). */
export const CoachingCadenceSchema = z.enum(['perDecision', 'perHand', 'perSeries', 'perSession']);
/** A pointer to one graded decision, with the grade and a one-line reason - the debrief's jump target. */
export const DecisionRefSchema = z.object({
    handId: z.string(),
    decisionIndex: z.number().int().nonnegative(),
    street: StreetSchema,
    grade: z.number().min(1).max(10),
    /** Short human reason: the leak statement for a worst pick, a positive note for a best pick. */
    note: z.string().optional(),
});
/** One cadence-grouped chunk of a run, graded as a unit with its best/worst decision surfaced. */
export const DebriefUnitSchema = z.object({
    scope: z.enum(['decision', 'hand', 'series', 'session']),
    /** Grouping key: `${handId}#${idx}` (perDecision), a handId (perHand), or a run label (series/session). */
    key: z.string(),
    handIds: z.array(z.string()),
    decisionCount: z.number().int().nonnegative(),
    avgGrade: z.number(),
    best: DecisionRefSchema.optional(),
    worst: DecisionRefSchema.optional(),
});
/** A run of hands graded as a unit at a chosen cadence, plus a run-wide best/worst rollup. */
export const SeriesDebriefSchema = z.object({
    cadence: CoachingCadenceSchema,
    units: z.array(DebriefUnitSchema),
    overall: z.object({
        handCount: z.number().int().nonnegative(),
        decisionCount: z.number().int().nonnegative(),
        avgGrade: z.number(),
        best: DecisionRefSchema.optional(),
        worst: DecisionRefSchema.optional(),
    }),
});
//# sourceMappingURL=progress.js.map